module.exports = __webpack_public_path__ + "static/img/07.683a422.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/brand/07.png
// module id = yR6+
// module chunks = 3